import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Title = () => {
  const { t } = useTranslation();
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="h6" fontWeight={700}>
        {t('Tasks')}
      </Typography>
    </Box>
  );
};

export default Title;
